import React, { Suspense } from "react";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "../components/app";
import { routes } from "./layouts-routes";
import { publicRoutes } from "./public-routes";
import { Loader } from "react-feather";

import configDB from "../data/customizer/config";
import PrivateRoute from "./private-route";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Debug = props => {
  return <>
    <span>Ola mundo</span>
  </>
}

const MainRoutes = () => {
  useEffect(() => {
    const abortController = new AbortController();
    const color = localStorage.getItem("color");
    const layout = localStorage.getItem("layout_version") || configDB.data.color.layout_version;
    document.body.classList.add(layout);
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/${color}.css`);

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <>
      <BrowserRouter basename="/">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={`${process.env.PUBLIC_URL}/debug`} element={<Debug />} />
            {publicRoutes.map(({ path, Component }, i) => (
              <Route key={`public-${i}`} exact path={path} element={Component} />
            ))}
            <Route path="/" element={<PrivateRoute />}>
              {routes.map(({ path, Component }, i) => (
                <Route key={`private-${i}`} element={<AppLayout />}>
                  <Route exact path={path} element={Component} />
                </Route>
              ))}
            </Route>
          </Routes>
        </Suspense>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </BrowserRouter>
    </>
  );
};

/*
const MainRoutes = () => {
  useEffect(() => {
    const abortController = new AbortController();
    const color = localStorage.getItem("color");
    const layout = localStorage.getItem("layout_version") || configDB.data.color.layout_version;
    document.body.classList.add(layout);
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/${color}.css`);

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <>
      <BrowserRouter basename="/">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={`${process.env.PUBLIC_URL}/`} element={App} />
            {publicRoutes.map(({ path, Component }, i) => (
              <Route exact path={path} element={Component} />
            ))}
            {routes.map(({ path, Component }, i) => (
              <Route element={<AppLayout />} key={i}>
                <Route exact path={path} element={Component} />
              </Route>
            ))}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};*/

export default MainRoutes;
